import { useNavigate } from 'react-router-dom';
import { useEffect, useRef, useState } from 'react';

const AdminPanel = () => {
  const navigate = useNavigate();
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const [iframeHeight, setIframeHeight] = useState('calc(100vh - 60px)');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Tentativa de ajustar o iframe para evitar uma barra de rolagem
    const handleResize = () => {
      setIframeHeight(`calc(100vh - 60px)`);
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleExit = () => {
    // Limpar dados de autenticação
    localStorage.removeItem('isLoggedIn');
    
    // Redirecionar para a página inicial
    window.location.href = 'http://localhost:8080/';
  };

  const handleIframeLoad = () => {
    setLoading(false);
  };

  return (
    <div className="flex flex-col h-screen">
      {/* Cabeçalho com botão sair */}
      <header className="bg-[#0e7cb4] text-white py-3 px-6 shadow-md">
        <div className="container mx-auto flex justify-between items-center">
          <h1 className="text-xl font-semibold">Painel Administrativo</h1>
          <button
            onClick={handleExit}
            className="flex items-center bg-white text-[#0e7cb4] hover:bg-gray-100 px-4 py-2 rounded font-medium"
          >
            <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 19l-7-7 7-7m8 14l-7-7 7-7"></path>
            </svg>
            Sair
          </button>
        </div>
      </header>

      {/* Indicador de carregamento */}
      {loading && (
        <div className="absolute inset-0 flex items-center justify-center bg-white bg-opacity-80 z-10" style={{top: '60px'}}>
          <div className="flex flex-col items-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#0e7cb4]"></div>
            <p className="mt-4 text-[#0e7cb4] font-medium">Carregando painel administrativo...</p>
          </div>
        </div>
      )}

      {/* Iframe contendo a página administrativa */}
      <iframe
        ref={iframeRef}
        src="https://id-preview--cf1c6eea-098f-432e-9a13-0cce0403434a.lovable.app/admin"
        style={{ height: iframeHeight, width: '100%', border: 'none' }}
        onLoad={handleIframeLoad}
        title="Painel Administrativo"
        sandbox="allow-same-origin allow-scripts allow-forms allow-popups"
      />
    </div>
  );
};

export default AdminPanel; 